if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.quantity__input');
      this.currentVariant = this.querySelector('.product-variant-id');
      this.variantSelects = this.querySelector('variant-radios');
      this.submitButton = this.querySelector('[type="submit"]');
    }

    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;

    connectedCallback() {
      this.quantityForm = this.querySelector('.product-form__quantity');
      if (!this.input && this.quantityForm) {
          this.setQuantityBoundries();
      }

      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      }
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const scentValue = this.querySelector('[name="Scent"]:checked').value;
        const scentDescriptionContainer = this.querySelector('.scent-description');
        const scentImageTextSection = document.querySelector('.image-with-text__scent');
        const mediaGalleryThumbs = document.querySelector('media-gallery .thumbnail-list');
        const packLinks = document.querySelector('.variant-picker__option-values .variation-products');
        if (scentDescriptionContainer) {
          const selected = scentDescriptionContainer.querySelector(`[data-scent="${scentValue}"]`);
          Array.from(selected.parentNode.children).forEach(sibling => {
            if (sibling !== selected) {
              sibling.classList.add('hidden');
            }
          });
          selected.classList.remove('hidden');
        }
        if (packLinks) {
          const selected = packLinks.querySelector(`[data-scent="${scentValue.toLowerCase()}"]`);
          Array.from(selected.parentNode.children).forEach(sibling => {
            if (sibling !== selected) {
              sibling.classList.add('hidden');
            }
          });
          selected.classList.remove('hidden');
        }
        if(scentImageTextSection) {
          const selected = scentImageTextSection.querySelector(`[data-scent="${scentValue}"]`);
          Array.from(selected.parentNode.children).forEach(sibling => {
            if (sibling !== selected) {
              sibling.classList.add('hidden');
            }
          });
          selected.classList.remove('hidden');
        }
        if (scentDescriptionContainer && mediaGalleryThumbs) {
          const thumbs = mediaGalleryThumbs.querySelectorAll('.thumbnail-list__item');
          const visibleThumbnails = Array.from(thumbs)
              .filter(item => window.getComputedStyle(item).display !== 'none');
          if (visibleThumbnails.length > 0) {
            visibleThumbnails[0].click();
          }
          const images = document.querySelectorAll('.slidermobile-gutter .product__media-item');
          thumbs.forEach(thumb => {
            if (thumb.dataset.alt === scentValue.toLowerCase()) {
              thumb.classList.remove('hidden')
            } else {
              thumb.classList.add('hidden')
            }
          });
          images.forEach(image => {
            if (image.dataset.alt === scentValue.toLowerCase()) {
              image.classList.remove('hidden')
            } else {
              image.classList.add('hidden')
            }
          });
          if ($(window).width() < 767) {
            $('.slidermobile-gutter ul').filter('.slick-initialized').slick('unslick');
            window.setTimeout(() => {
              $('.slidermobile-gutter ul').slick({
                dots: true,
                infinite: true,
                speed: 500,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                slide: '.product__media-item:visible'
              });
            }, 200)
          }
        }
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        if (event.data.sectionId !== sectionId) return;
        if (this.quantityForm) {
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        }
      });
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }

    setQuantityBoundries() {
      const data = {
        cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
        min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
        max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
        step: this.input.step ? parseInt(this.input.step) : 1
      }

      let min = data.min;
      const max = data.max === null ? data.max : data.max - data.cartQuantity;
      if (max !== null) min = Math.min(min, max);
      if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

      this.input.min = min;
      this.input.max = max;
      this.input.value = min;
      publish(PUB_SUB_EVENTS.quantityUpdate, undefined);  
    }

    fetchQuantityRules() {
      if (!this.currentVariant || !this.currentVariant.value || !this.quantityForm) return;
      this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
      fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`).then((response) => {
        return response.text()
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        if (this.quantityForm) {
          this.updateQuantityRules(this.dataset.section, html);
          this.setQuantityBoundries();
        }
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
      });
    }

    updateQuantityRules(sectionId, html) {
      const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
      const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
      for (let selector of selectors) { 
        const current = this.quantityForm.querySelector(selector);
        const updated = quantityFormUpdated.querySelector(selector);
        if (!current || !updated) continue;
        if (selector === '.quantity__input') {
          const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
          for (let attribute of attributes) {
            const valueUpdated = updated.getAttribute(attribute);
            if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
          }
        } else {
          current.innerHTML = updated.innerHTML;
        }
      }
    }
  }
)};



